export default __webpack_public_path__ + "f3c42acea6ed9b410a1130eca4ca645d.png";